import { alpha, darken } from '@mui/material';
import { tss } from 'tss-react/mui';

import {
  VMP_OUTLINED_FILLED_COLORS,
  VMP_SOLID_COLORS
} from '@/constants/chartcolors.constants';
import type { CriticalityTypes } from '@/pages/VulnerabilityManagement/VulnerabilityManagement.types';
import type { ThemeMode } from '@/types/theme.ts';

const useStyles = tss
  .withParams<{
    themeMode: ThemeMode;
    value?: string;
  }>()
  .create(({ theme, themeMode, value }) => {
    const formattedValue = value?.toUpperCase() || null;
    const outlinedColor =
      formattedValue &&
      VMP_OUTLINED_FILLED_COLORS[formattedValue as CriticalityTypes]
        ? VMP_OUTLINED_FILLED_COLORS[formattedValue as CriticalityTypes]
        : theme.palette.grey[600];
    const solidColor =
      formattedValue && VMP_SOLID_COLORS[formattedValue as CriticalityTypes]
        ? VMP_SOLID_COLORS[formattedValue as CriticalityTypes]
        : theme.palette.grey[600];

    return {
      outlinedChip: {
        position: 'relative',
        overflow: 'visible',
        border: '1px solid',
        borderColor:
          themeMode === 'light' ? darken(outlinedColor, 0.5) : outlinedColor,
        backgroundColor:
          themeMode === 'light'
            ? alpha(outlinedColor, 0.3)
            : alpha(outlinedColor, 0.1),
        color:
          themeMode === 'light' ? darken(outlinedColor, 0.4) : outlinedColor
      },
      solidChip: {
        position: 'relative',
        overflow: 'visible',
        textTransform: 'capitalize',
        backgroundColor: solidColor,
        color:
          formattedValue === 'CRITICAL' ||
          formattedValue === 'LOW' ||
          !formattedValue
            ? theme.vars.palette.common.white
            : theme.vars.palette.common.black
      }
    };
  });

export default useStyles;
